import { render, staticRenderFns } from "./edit_info.vue?vue&type=template&id=223a52ac&scoped=true"
import script from "./edit_info.vue?vue&type=script&lang=js"
export * from "./edit_info.vue?vue&type=script&lang=js"
import style0 from "./edit_info.vue?vue&type=style&index=0&id=223a52ac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a52ac",
  null
  
)

export default component.exports